import storage from '@/plugins/storage.plugins.js';

const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
const PERSONAL_SCOPE = 'personal';
const normalizedOrganizationId = context => context.organizationId || null;
const keyFor = ({ userId, organizationId, patientId, encounterId }) => {
    const scope = organizationId ? `organization=${organizationId}` : PERSONAL_SCOPE;
    if (![userId, scope, patientId, encounterId].every(value => typeof value === 'string' && value && !value.includes(':'))) {
        throw new Error('Contexto incompleto para o rascunho');
    }
    return `clinical_draft:${userId}:${scope}:${patientId}:${encounterId}`;
};

export default {
    async save(context, data) {
        const key = keyFor(context);
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            throw new Error('Conteúdo inválido para o rascunho');
        }
        await storage.clinicalDraftStorage('write', key, {
            version: 2,
            userId: context.userId,
            organizationId: normalizedOrganizationId(context),
            patientId: context.patientId,
            encounterId: context.encounterId,
            savedAt: Date.now(),
            data
        });
    },
    async load(context) {
        const key = keyFor(context);
        let value;
        try {
            value = await storage.clinicalDraftStorage('read', key);
        } catch {
            try { await storage.clinicalDraftStorage('delete', key); } catch { /* inválido permanece apenas até a próxima limpeza */ }
            return { invalid: true };
        }
        if (!value) return null;
        const expired = !Number.isFinite(value.savedAt) || Date.now() - value.savedAt > MAX_AGE;
        const valid = value && typeof value === 'object' && !Array.isArray(value) &&
            value.version === 2 && value.data && typeof value.data === 'object' &&
            !Array.isArray(value.data) && !expired &&
            value.organizationId === normalizedOrganizationId(context) &&
            ['userId', 'patientId', 'encounterId'].every(field => value[field] === context[field]);
        if (!valid) {
            try { await storage.clinicalDraftStorage('delete', key); } catch { /* não bloquear a abertura por falha de limpeza */ }
            if (expired) return null;
            return { invalid: true };
        }
        if (value.savedAt > Date.now() + 5 * 60 * 1000) {
            try { await storage.clinicalDraftStorage('delete', key); } catch { /* não bloquear a abertura por falha de limpeza */ }
            return { invalid: true };
        }
        return value;
    },
    async remove(context) {
        await storage.clinicalDraftStorage('delete', keyFor(context));
    },
    async clearUser(userId) {
        await storage.clearClinicalDraftsForUser(userId);
    }
};
